import React, { useState, useEffect } from "react";
import axios from "axios";
import CONFIG from "./config";
import CustomAlert from "./CustomAlert";
import { useNavigate, useLocation } from "react-router-dom";
import "./AddbBlogform.css";
import Swal from "sweetalert2";
import { FaTimes, FaEye, FaDownload } from "react-icons/fa";

const ViewJobApplicationDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const jobData = location.state?.jobProbsData || {};

  return (
    <div className="modal-overlay  admin_modal_preview create_career_details">
      <div className="custom-modal-content">
        <div className="col-md-12 custom-modal-title text-left">
          <h2 className="mt-0">Job Details</h2>
        </div>
        <div className="custom-form-group mt-4 closepreview text-right">
          <button
            type="button"
            className="custom-btn-cancel"
            onClick={() => navigate("/job-application-table")}
          >
            <FaTimes />
          </button>
        </div>
        <div className="career-details">
          <div className="col-md-12 form-group">
            <label>Job Id</label>
            <span>:</span>
            <p> {jobData.applicationId} </p>
          </div>
          <div className="col-md-12 form-group">
            <label>Job Title</label>
            <span>:</span>
            <p> {jobData.jobTitle} </p>
          </div>
          <div className="col-md-12 form-group">
            <label>Firast Name</label>
            <span>:</span>
            <p> {jobData.firstName} </p>
          </div>
          <div className="col-md-12 form-group">
            <label>Last Name</label>
            <span>:</span>
            <p> {jobData.lastName} </p>
          </div>
          <div className="col-md-12 form-group">
            <label>Phone</label>
            <span>:</span>
            <p> {jobData.phone} </p>
          </div>
          <div className="col-md-12 form-group">
            <label>Email</label>
            <span>:</span>
            <p> {jobData.email} </p>
          </div>
          <div className="col-md-12 form-group">
            <label>Experience</label>
            <span>:</span>
            <p> {jobData.experience} </p>
          </div>
          <div className="col-md-12 form-group">
            <label>Cover letter</label>
            <span>:</span>
            <p> {jobData.coverLetter}</p>
          </div>
          <div className="col-md-12 resume_wrap form-group">
            <label>Resume</label>
            <span>:</span>
            <a className="resume_download" href={jobData.resume} download>
              <FaDownload
                size={18}
                style={{ marginLeft: "12px", color: "#28a745" }}
                title="Download Resume"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewJobApplicationDetails;
